<template>
    <div class="loginPage flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4 relative">
      <h1 class="logo-text">interbot</h1>
      <div class="mb-6 w-full max-w-xs">
        <input
          v-model="interviewCode"
          type="text"
          placeholder="Código Personal de Entrevista"
          class="interview-code-input shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
      <button
        :disabled="!isCodeValid"
        @click="goToInterbot"
        class="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition transform hover:scale-105  disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
        :class="{'bg-green-500 hover:bg-green-700' : isPractice, 'bg-blue-500 hover:bg-blue-700': !isPractice }"
        >
        {{ isCodeValid ? 'EMPEZAR' : 'Introduce tu Código' }}
      </button>
      <br>
      <h4 class="text-gray-600 text-center mt-4 mb-6">¿No tienes código? Puedes hacer una entrevista de práctica.</h4>
      <button
        :disabled="isCodeValid"
        @click="goToInterbot"
        class="login-button bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition transform hover:scale-105  disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
      >
        Entrevista de Práctica
      </button>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: "loginPage",
    data() {
      return {
        interviewCode: "",
         isCodeValid: false,
         debouncedCheck: null,
         isPractice: true,
      };
    },
      watch: {
        interviewCode(newValue) {
          this.validateCode(newValue);
        },
      },
    mounted() {
      const codeFromUrl = this.$route.query.code;
      localStorage.removeItem("chatSessionId");
      if (codeFromUrl) {
        this.interviewCode = codeFromUrl;
      }
    },
    methods: {
       async validateCode(code) {
           // Cancelar la llamada anterior
             if (this.debouncedCheck) {
               clearTimeout(this.debouncedCheck);
             }
  
             this.isCodeValid = false; // Deshabilitar el botón mientras se valida
  
              if (code.length !== 36) {
                  return;
               }
  
            this.debouncedCheck =  setTimeout(async () => {
                  try {
                    const response = await axios.get('./api/check-session', {
                      params: {
                          chatSessionId: code
                      }
                  });
                     this.isCodeValid = response.data.chatSessionExists;
                     this.isPractice = response.data.isPractice;
                  } catch (error) {
                  console.error("Error checking session:", error);
                   this.isCodeValid = false;
                  }
              }, 500)
          },
      goToInterbot() {
        const queryParams = {};
        if (this.interviewCode && this.isCodeValid) {
          queryParams.code = this.interviewCode;
        }
        this.$router.push({
          name: "Interbot",
          query: queryParams,
        });
      },
        goToLink(link) {
          this.$router.push(link);
        },
        togglePlan(index) {
        this.selectedPlan = this.selectedPlan === index ? null : index;
      },
    },
  };
  </script>
  <style scoped>
  .pricing-card.expanded {
    max-width: none !important;
    flex: 0 0 100% !important;
    min-width: auto !important;
  }
  </style>